import React from 'react';
import styles from '../Operations.module.css';

interface BTESComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const BTES: BTESComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
        This metric displays the sales $ from existing business segmented customers from the current year rolling 12-month B2B sales.
        <br />
        • For the purpose of this metric, &quot;current year&quot; is defined as the most recent consecutive 12 months, and &quot;prior year&quot; is defined as the 12 months immediately preceding &quot;current year&quot;.
        <br />
        • New customers are defined as those that only have sales in the most recent rolling 12 months for the calculation year. Once a customer has sales going back longer than 12 months, they are considered existing customers.
        <br />
        • Segmented business customers without any transactions in the past 12 months are not counted.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>
      <div className={styles.sectionContent}>
        The goal for Existing Customer Sales $ is derived from the YOY Growth $ goal. The goal is to work toward a healthy store model with 70% of the YOY Growth $ goal from existing customers, and the other 30% from new customers.
      </div>

      <div className={styles.sectionTitle}>
        Drill Down
      </div>
      <div className={styles.sectionContent}>
        Drill down provides the ability to see the YOY results by customer segment including sales, average transaction, and transaction count, among existing customers.
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        Consult with your Field Sales Manager and review/implement the Business to Business training and B2B Playbook to build the culture and practices to grow the relationships and sales with your local business customers. Sales training and product specific support is available in the form of B2B Vendor sales programs, B2B Monthly Sales Strategies with monthly vendor Lunch and Learn sales trainings. 
      </div>
    </div>
  );
};

BTES.title = 'Business to Business Metrics (Existing Customer Sales $)';
export default BTES;

